import { render, staticRenderFns } from "./EventHighlightCard.vue?vue&type=template&id=2104458b&"
import script from "./EventHighlightCard.vue?vue&type=script&lang=ts&"
export * from "./EventHighlightCard.vue?vue&type=script&lang=ts&"
import style0 from "./EventHighlightCard.vue?vue&type=style&index=0&id=2104458b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports